import { render } from "./ForFormalTrade.vue?vue&type=template&id=7bb40220&scoped=true&ts=true"
import script from "./ForFormalTrade.vue?vue&type=script&lang=ts"
export * from "./ForFormalTrade.vue?vue&type=script&lang=ts"

import "./ForFormalTrade.vue?vue&type=style&index=0&id=7bb40220&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb40220"]])

export default __exports__